export const getDntActive = () => {
  const dntActive = parseInt(
    navigator.msDoNotTrack || window.doNotTrack || navigator.doNotTrack,
    10
  );

  return dntActive === 1;
};
